export default function getPublicUrl(path) {
  if (!path) return null;
  if (getCDNPublicAvatarUrl(path)) {
    return getCDNPublicAvatarUrl(path);
  }
  let normalizedPath = path;
  let timestampParams = "";
  if (path.startsWith("/")) normalizedPath = normalizedPath.slice(1);
  // strip timestramp
  if (normalizedPath.includes("?v=")) {
    const splited = normalizedPath.split("?");
    if (splited.length > 1) timestampParams = `&${splited[1]}`;
    normalizedPath = splited[0];
  }
  const endpoint =
    (import.meta.env.VITE_FIREBASE_EMULATOR_ENABLE === "true"
      ? "http://localhost:9199"
      : "https://firebasestorage.googleapis.com") + "/v0";
  return `${endpoint}/b/${import.meta.env.VITE_FIREBASE_STORAGE_BUCKET}/o/${encodeURIComponent(
    normalizedPath,
  )}?alt=media${timestampParams}`;
}

export function getCDNPublicAvatarUrl(path, dim='512') {
  if (!(path?.includes("creators"))) return "";
  let normalizedPath = path;

  // Extract query params if any
  let queryParams = "";
  const questionMarkIndex = normalizedPath.indexOf("?");
  if (questionMarkIndex !== -1) {
    queryParams = normalizedPath.substring(questionMarkIndex);
    normalizedPath = normalizedPath.substring(0, questionMarkIndex);
  }

  // Replace 'picture.EXT' with 'picture_DIM.EXT', keeping the extension
  normalizedPath = normalizedPath.replace(/picture\.([a-zA-Z0-9]+)$/, `picture_${dim}.$1`);

  // Only return CDN url if the transformation actually occurred (file name changed)
  if (!normalizedPath.includes(`picture_${dim}.`)) {
    return "";
  }

  return `https://stream-cdn.nightco.io/${normalizedPath}${queryParams}`;
}
